


/*scripts after main content*/
/* ----- popup scripts ----- */
$(document).on('click', '.popupButton', function (e) {
    var target = $(this).data('target');
    $('.' + target).fadeIn(250, function () {
        $('.' + target + ' .popupContainer, .' + target + ' .newPopupContainer').show();
        $('.' + target + ' .popupContainer, .' + target + ' .newPopupContainer').animate({
            top: '50%'
        }, 200);
    });
});

$('.popupBG').on('click', function () {
    var container = $(this).siblings('.popupContainer, .newPopupContainer');
    container.animate({
        top: '200%'
    }, 200, function () {
        container.hide();
        container.parent().fadeOut(150);
    });
});

$('.customPopup .closeButton').on('click', function (e) {
    var container = $(this).closest('.popupContainer');
    container.animate({
        top: '200%'
    }, 200, function () {
        container.hide();
        container.parent().fadeOut(150);
    });
});

$('.newCustomPopup .closeButton').on('click', function (e) {
    var container = $(this).closest('.newPopupContainer');
    container.animate({
        top: '200%'
    }, 200, function () {
        container.hide();
        container.parent().fadeOut(150);
    });
});

/* ----- to be able to show country popup after the cookie popup is closed. ----- */
window.addEventListener('PandectesEvent_OnConsent', (function(e) {
    if(e.detail && e.detail.consentType != 'default'){
        // console.log('N');
        getUserCountry();
    }else{
        // console.log('O');
    }
}));


/* ----- script to detect users country and redirect to relevant domain ----- */
let saveCountryToStorage = function(country) {

    let currentData = localStorage.getItem('geo_countries_saved');
    if(currentData) {
        currentData = JSON.parse(currentData);
    }
    if(!currentData || !Array.isArray(currentData)) {
        currentData = [];
    }

    let found = currentData.find(function(e) {
        return e == country;
    });

    if(found) {
        return;
    }

    currentData.push(country);

    localStorage.setItem('geo_countries_saved', JSON.stringify(currentData));

}

let checkCountryExistsInStorage = function(country) {

    let currentData = localStorage.getItem('geo_countries_saved');
    if(currentData) {
        currentData = JSON.parse(currentData);
    }
    if(!currentData || !Array.isArray(currentData)) {
        currentData = [];
    }

    let found = currentData.find(function(e) {
        return e == country;
    });

    return found;

}


let eurCountries = ['BE', 'NL', 'PT', 'AT', 'FI', 'FR', 'DE', 'IE', 'IT', 'LU', 'ES', 'GR'];
let middleEastCountries = ['BH', 'KW', 'OM', 'QA', 'SA', 'AE'];

$(window).click(function () {
    $('.countryPopupSelectOptions').hide();
    $('.countryPopupSelect').attr('aria-expanded', false);
    $('.countryPopupSelect .countryPopupSelectValue').attr('aria-expanded', 'false');
});

$('.countryPopupOverlay').on('click', function () {
    if ($('.countryPopupSelect[aria-expanded="true"]').length > 0) {
        return;
    }
    saveCountryToStorage(window.active_country_code);
    $('.countryPopup').hide();
    $(window).on('click.klaviyo scroll.klaviyo mousemove.klaviyo', klaviyoTriggerFunc);
});

$('.countryPopupSelectValue:not(.disabled)').on('click', function (e) {
    e.stopPropagation();

    let $this = $(this);
    let $topic = $this.parent();
    let $items = $topic.find('.countryPopupSelectOptions');
    let isExpanded = $topic.attr('aria-expanded') !== 'false';

    if (!isExpanded) {
        $items.show();
    } else {
        $items.hide();
    }

    $topic.attr('aria-expanded', !isExpanded);
    $this.attr('aria-expanded', !isExpanded);
    if (!isExpanded) { $items.find('.countryPopupSelectOption').first().focus(); }
});

$('.countryPopupSelectOption').click(function (event) {
    let $select = $(this).closest('.countryPopupSelect');
    let $selectValue = $select.find('.countryPopupSelectValue');
    let $options = $select.find('.countryPopupSelectOptions');
    let value = $(this).data('value');

    $selectValue.text($(this).text());
    $select.data('value', value);
    $options.hide();
    $select.attr('aria-expanded', false);
    $selectValue.attr('aria-expanded', 'false');
    $selectValue.focus();
    if ($(this).data('currency')) {
        $('#countryPopupCurrency').html($(this).data('currency'));
    }
});

// Keyboard activation for the country popup's click-driven controls (the custom
// select trigger, its options, and Save/Continue).
$('body').on('keydown', '.countryPopupSelectValue:not(.disabled), .countryPopupSelectOption, .countryPopupButton, .countryPopupContinueButton', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        $(this).trigger('click');
    }
});

// Focus management for the geo-detect country popup: move focus in on open,
// trap Tab within the dialog, and let Esc dismiss (= Continue).
var __countryPopupKeydown = null;
function openCountryPopupA11y() {
    var dialog = document.querySelector('.countryPopup .countryPopupContainer');
    if (!dialog) return;
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    setTimeout(function () { dialog.focus(); }, 0);

    if (__countryPopupKeydown) document.removeEventListener('keydown', __countryPopupKeydown, true);
    __countryPopupKeydown = function (e) {
        if ($('.countryPopup').css('display') === 'none') return;
        if (e.key === 'Escape' || e.key === 'Esc') {
            e.preventDefault();
            $('.countryPopupContinueButton').trigger('click');
            document.removeEventListener('keydown', __countryPopupKeydown, true);
            __countryPopupKeydown = null;
            return;
        }
        if (e.key === 'Tab') {
            var f = Array.prototype.filter.call(
                dialog.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"]), [role="button"], [role="option"]'),
                function (el) { return el.offsetParent !== null; });
            if (!f.length) return;
            var first = f[0], last = f[f.length - 1];
            if (!dialog.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
            else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
    };
    document.addEventListener('keydown', __countryPopupKeydown, true);
}

var userCountry = null;

$('.countryPopupButton:not(.disabled)').on('click', function() {
    let val = $('.countryPopupSelectSelect').data('value');
    if(!val) {
        $('.countryPopup').hide();
        $(window).on('click.klaviyo scroll.klaviyo mousemove.klaviyo', klaviyoTriggerFunc);
        return;
    }

    $('.countryPopupButton').addClass('disabled');

    if (isUSSite && val != 'US') {
        window.location = 'https://' + globalHost + window.location.pathname + '?country=' + val;
    } else if (!isUSSite && val === 'US') {
        window.location = 'https://' + usHost + window.location.pathname + '?country=US';
    } else {
        let $form = $('<form method="POST" action="/localization" style="display:none">');
        $form.append($('<input type="hidden" name="_method" value="PUT">'));
        $form.append($('<input type="hidden" name="country_code">').val(val));
        $form.append($('<input type="hidden" name="return_to">').val(window.location.pathname));
        $('body').append($form);
        $form.submit();
    }
});

$('.countryPopupContinueButton').on('click', function() {
    saveCountryToStorage(window.active_country_code);

    $('.countryPopup').hide();

    $(window).on('click.klaviyo scroll.klaviyo mousemove.klaviyo', klaviyoTriggerFunc);
});

var subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;

function getUserCountry() {
    $.get('https://sapi.sheepinc.com/api/location', function(data) {
        userCountry = data.countryCode;
        checkUserCountry();
    });
}


$(window).on('load', whenPageLoaded());

setTimeout(function() {
    whenPageLoaded();
}, 8000);

function whenPageLoaded() {
    $('.pageLoader').fadeOut(200, function() {
        $(this).remove();
    });
}

let klaviyoTriggerFunc = function () {

    window.addEventListener("klaviyoForms", function(e) {
        if (e.detail.type == 'open') {
            // Custom JS
            // console.log("open");
            // console.log(e);
        }else if (e.detail.type == 'submit') {
            // console.log("e");
            // console.log(e);
            // console.log(JSON.stringify(e.detail));
            //todo: get email manually here
            let em = $('form.klaviyo-form input[type=email]').val();
            // console.log(em);
            let email = "-";
            if(e.detail.metaData['$email']){
                email = e.detail.metaData['$email'];
            }
            $.post('https://sapi.sheepinc.com/api/klaviyo/log-form-submit', {email: email,email_manual: em, locale: 'UK', data: JSON.stringify(e.detail)}, function () {
            });
        }else if (e.detail.type == 'stepSubmit') {
            // console.log("STEP SUBMIT");
            // console.log(e);
            // // console.log(JSON.stringify(e.detail));
            //
            // let em = $('form.klaviyo-form input[type=email]').val();
            // let email = "--";
            // if(e.detail.metaData['$email']){
            //     email = e.detail.metaData['$email'];
            // }
            // $.post('https://sapi.sheepinc.com/api/klaviyo/log-form-submit', {email: email,email_manual: em,data_step: JSON.stringify(e.detail)}, function () {
            // });
        }
    });


    $(window).off('click.klaviyo scroll.klaviyo mousemove.klaviyo');
    if(!shouldShowKlaviyo()) return;
    const prohibitedStrings = ["/nfc?", "/nfc-new?", "account", "checkouts"];
    const currentURL = window.location.href;

    for (let i = 0; i < prohibitedStrings.length; i++) {
        if (currentURL.includes(prohibitedStrings[i])) {
            return;
        }
    }

    $('.klaviyo-teaser-close').on('click', function() {
        localStorage.setItem('klaviyo-popup-trigger-date', Date.now());
        $('.klaviyo-teaser').removeClass('active');
    });
    $('.klaviyo-teaser-content').on('click', function() {
        localStorage.setItem('klaviyo-popup-trigger-date', Date.now());
        let formID = isUSSite?'TLafud':'WETkPc';
        // console.log(formID);
        window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', formID]);
    });




    setTimeout(function() {
        $('.klaviyo-teaser').addClass('active');

    }, 2000);


    setTimeout(function() {
        if(!shouldShowKlaviyo()) return;
        let formID = isUSSite?'TLafud':'WETkPc';
        window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', formID]);
        localStorage.setItem('klaviyo-popup-trigger-date', Date.now());
    }, 7000);


    function shouldShowKlaviyo(){
        //hide klaviyo teaser for BF
        return false;
        // if (localStorage.getItem('klaviyo-popup-trigger-block')){
        //     return false;
        // }else if (localStorage.getItem('klaviyo-popup-trigger-date')){
        //     let d1 = new Date(parseInt(localStorage.getItem('klaviyo-popup-trigger-date'))).getTime();
        //     let d2 = Date.now();
        //     const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        //     let diff =Math.floor((d2 - d1) / _MS_PER_DAY);
        //     return diff > 30;
        //
        // }
        // return true;
    }
};

function checkUserCountry() {
    if(!window.location.host.includes('sheepinc.com') || isbot(navigator.userAgent) || !userCountry) {
        $(window).on('click.klaviyo scroll.klaviyo mousemove.klaviyo', klaviyoTriggerFunc);
        return;
    }

    if(userCountry == 'UK') {
        userCountry = 'GB';
    }

    if(userCountry in currencyNames && userCountry in currencyCountryCodes) {
        $('#countryPopupCurrency').html(currencyNames[userCountry]);
        $('.countryPopupCountryName').html(currencyCountryCodes[userCountry]);
        $('.countryPopupSelectSelect').data('value', userCountry);

        //ilki giriş yapan ve current aynı değil ise true, ikincisi giriş yapan kayıtlı değil ise true
        if(window.active_country_code != userCountry && !checkCountryExistsInStorage(window.active_country_code)) {
            $('.countryPopup').show();
            openCountryPopupA11y();
            return;
        }
    }
    $(window).on('click.klaviyo scroll.klaviyo mousemove.klaviyo', klaviyoTriggerFunc);
}

var __locationLastFocus = null;
var __locationKeydown = null;

function openLocationPopup(trigger) {
    __locationLastFocus = trigger || document.activeElement;
    $('.locationPopup').show();
    $('.footerCountrySelector').attr('aria-expanded', 'true');

    var dialog = document.querySelector('.locationPopup .locationPopupContainer');

    // Esc closes; Tab is trapped within the dialog.
    __locationKeydown = function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeLocationPopup(); return; }
        if (e.key === 'Tab' && dialog) {
            var f = Array.prototype.filter.call(
                dialog.querySelectorAll('a[href], button, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"]), [role="button"]'),
                function (el) { return el.offsetParent !== null; });
            if (!f.length) return;
            var first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
    };
    document.addEventListener('keydown', __locationKeydown, true);

    if (dialog) {
        if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
        setTimeout(function () { dialog.focus(); }, 0);
    }
}

function closeLocationPopup() {
    $('.locationPopup').hide();
    $('.footerCountrySelector').attr('aria-expanded', 'false');
    if (__locationKeydown) {
        document.removeEventListener('keydown', __locationKeydown, true);
        __locationKeydown = null;
    }
    if (__locationLastFocus && typeof __locationLastFocus.focus === 'function') {
        __locationLastFocus.focus();
    }
    __locationLastFocus = null;
}

$('.locationPopupCloseButton, .locationPopupOverlay').on('click', function() {
    closeLocationPopup();
});
$('.locationPopupCloseButton').on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); closeLocationPopup(); }
});

$('.footerCountrySelector').on('click', function() {
    openLocationPopup(this);
});
$('.footerCountrySelector').on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); $(this).trigger('click'); }
});
/* ----- menu scripts ----- */


$(function() {

    $('.navigation__link-sub > a, .submenuItem').on('click', function(event) {

        event.preventDefault();

        var $this = $(this);
        var $submenu = $(this).find('ul.navigation__links');
        var $downArrow = $(this).find('.navigation__link--down-arrow');

        if($submenu.length == 0) {
            $submenu = $(this).parent().find('ul.navigation__links');
        }

        if($downArrow.length == 0) {
            var $downArrow = $(this).parent().find('.navigation__link--down-arrow');
        }

        if($this.data('active')) {
            $submenu.slideUp();
            $this.data('active', false);
            $downArrow.css('transform', 'rotate(0deg)');
            $('.site-header').removeClass('site-header--dropdown-active');
        } else {
            $('.submenuContainer ul.navigation__links').slideUp();
            $submenu.slideDown();
            $this.data('active', true);
            $downArrow.css('transform', 'rotate(180deg)');
            $('.site-header').addClass('site-header--dropdown-active');
        }

    });

});

/* ----- notouch script ----- */

document.documentElement.className +=
    (("ontouchstart" in document.documentElement) ? ' touch' : ' no-touch');


/* ----- ???form clear script??? ----- */
$(function() {

    var formCleared = false;
    function clearForm() {

        setTimeout(function () {
            $('.product-form').each(function (i, form) {
                var events = $._data(form, 'events' );
                if (events && events.submit && events.submit.length > 0) {
                    events.submit.forEach(function(e) {
                        if(e.handler.toString().includes('Added Product')) {
                            $(form).unbind('submit', e.handler);
                            formCleared = true;
                        }
                    });
                }
            })

            if(!formCleared) {
                clearForm();
            }
        }, 500);

    }

    clearForm();
});


/* ----- lazyload additional script ----- */

document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
    var videoSrc = e.target.getAttribute('data-video-src');
    if(videoSrc){
        let $this = $(e.target);
        var $source = $this.find('source');
        if(!$source.attr('src')) {
            $source.attr('src', videoSrc);
            $this[0].load();
        }
    }
});




/* ----- recent searches script ----- */


$(function(){
    if(localStorage.getItem('recentSearchSaved') !== 'false') {
        return;
    }

    let searchString = localStorage.getItem('recentSearchItems');
    let searchItems = [];
    if(searchString != null) {
        searchItems = JSON.parse(searchString);
    }

    if(searchItems.length > 0) {
        let lastItem = searchItems[searchItems.length - 1];

        //check if session id exists
        let sessionID = sessionStorage.getItem('search_sessionID');
        if(!sessionID) {
            sessionID = UUIDv4.generate();
            sessionStorage.setItem('search_sessionID', sessionID);
        }

        lastItem['session_id'] = sessionID;

        $.ajax({
            type: "POST",
            url: "https://sapi.sheepinc.com/api/search",
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(lastItem),
            success: function (e) {},
            error: function (e) {
                console.log(e);
            }
        });

        localStorage.setItem('recentSearchSaved', 'true');
    }
});

$(function(){
    var fullHeightStyle = $('#fullHeightStyle');
    var lastWindowHeight = 0;
    function setFullHeightStyle() {
        let headerHeight = $('sticky-header').height();
        var windowHeight = document.documentElement.clientHeight - headerHeight;

        var diff = windowHeight - lastWindowHeight;
        if (diff < 0) {
            diff *= -1;
        }
        if (diff > 200) {
            fullHeightStyle.remove();
            fullHeightStyle = $('<style id="fullHeightStyle">.fullHeight {height: '+windowHeight+'px;} @media only screen and (max-width: 992px) { .fullHeightMobile {height: '+windowHeight+'px !important;}}</style>');
            fullHeightStyle.insertAfter('#fullHeightPreStyle');
            $('.pageContainer').css('margin-top', windowHeight+'px');
            lastWindowHeight = windowHeight;
        }
    }

    setFullHeightStyle()
    $(window).resize(function() {
        setFullHeightStyle();
    });
});

// $(function(){
//     setAnnouncementDate();
//     const numberOfIterations = 24; // Change this to the desired number
//     let iterations = 0;
//     const intervalId = setInterval(function () {
//         setAnnouncementDate();
//       iterations++;
//       if (iterations === numberOfIterations) {
//         clearInterval(intervalId);
//       }
//     }, 5000);
// });
//
// function setAnnouncementDate(){
//     let finalDate = new Date('Dec 21 2023 14:00:59 GMT')
//     // let finalDate = new Date('Dec 6 2023 12:19:59 GMT+0300');
//     if (cartCurrency == 'USD'){
//         finalDate = new Date('Dec 18 2023 00:00:59 GMT-0800');
//     }else if (cartCurrency == 'EUR'){
//         finalDate = new Date('Dec 18 2023 00:00:59 GMT');
//     }else if (cartCurrency == 'AUD' || cartCurrency == 'NZD'){
//         finalDate = new Date('Dec 14 2023 14:00:59 GMT+1100');
//     }else if (cartCurrency == 'GBP'){
//         finalDate = new Date('Dec 21 2023 14:00:59 GMT')
//     }else{
//         finalDate = new Date('Dec 18 2023 00:00:59 GMT');
//     }
//     const now = new Date();
//     const difference = finalDate - now;
//
//     if (difference <= 0) {
//         $('.announcement-bar').hide();
//         return;
//     }
//
//
//     const days = Math.floor(difference / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
//
//     if (days == 0 && hours == 0 && minutes == 0) {
//         $('.announcement-bar').hide();
//         return;
//     }
//     let result = '';
//     if (days > 0) {
//         result += days + ' day' + (days > 1 ? 's' : '') + ' ';
//     }
//     if (hours > 0) {
//         if(minutes == 0 && days > 0){
//             result += 'and ';
//         }
//         result += hours + ' hour' + (hours > 1 ? 's' : '') + ' ';
//     }
//     if (minutes > 0) {
//         if(hours > 0 || days > 0 ){
//             result += 'and ';
//         }
//         result += minutes + ' minute' + (minutes > 1 ? 's' : '');
//     }
//
//     let text = result + ' left for guaranteed pre-Christmas delivery.';
//     $('.announcement-bar__message span').html(text);
// }



